import { BUSINESS_PAGE_URL, GIFT_CARD, PHOTO_WALL_URL } from 'config/config'
import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { QuantityControlMode } from './components/ProductSummarySegment/ProductSummarySegment.types'

export const CART_DISABLED_URLS = [PHOTO_WALL_URL, GIFT_CARD, BUSINESS_PAGE_URL]

export function isCartExcludedPath(pathname: string) {
  return CART_DISABLED_URLS.some(
    (url) => pathname === url || pathname.startsWith(`${url}/`)
  )
}

export const BAG_OPEN_SOURCE = {
  TOP_BAR: 'Top Bar',
  DESIGNER: 'Designer',
} as const

export type BagOpenSource =
  (typeof BAG_OPEN_SOURCE)[keyof typeof BAG_OPEN_SOURCE]

export const CHECKOUT_ENTRY_POINT = {
  CHECKOUT_SHEET: 'Checkout Sheet',
  BAG_EXPRESS_CHECKOUT: 'Bag Express Checkout',
} as const

export type CheckoutEntryPoint =
  (typeof CHECKOUT_ENTRY_POINT)[keyof typeof CHECKOUT_ENTRY_POINT]

export const QUANTITY_CONTROL_MODE: Partial<
  Record<PRODUCT_TYPES, QuantityControlMode>
> = {
  [PRODUCT_TYPES.PHOTO_BOOK]: 'full',
  [PRODUCT_TYPES.CLASSIC]: 'minus-only',
}
